<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Cutter Overview</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-4">
            <v-select
              :options="devices"
              multiple
              v-model="data.imei"
              placeholder="Select Device"
            />
          </div>
          <div class="col-md-3">
            <datepicker
              :clear-button="true"
              placeholder="From Date"
              v-model="data.from_date"
              input-class="form-control"
            >
            </datepicker>
          </div>
          <div class="col-md-3">
            <datepicker
              :clear-button="true"
              placeholder="To Date"
              v-model="data.to_date"
              input-class="form-control"
            >
            </datepicker>
          </div>
          <div class="colmd-2">
            <button class="btn btn-success" @click="getOverview()">
              Submit
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th
                      v-for="(row, index) in rows"
                      :key="index"
                      class="text-center"
                    >
                      {{ formatDate(row.date) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="(row, index) in rows" :key="index">
                      <table>
                        <tr>
                          <th>#</th>
                          <th>Order No.</th>
                          <th>Fabric</th>
                        </tr>
                        <tr v-for="(log, subIndex) in row.logs" :key="subIndex">
                          <td>{{ subIndex + 1 }}</td>
                          <td>{{ log.shirt_order_id }}</td>
                          <td>{{ log.fabric_id }}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      data: {},
      rows: [],
      devices: [],
    };
  },
  mounted() {
    this.getDevices();
  },

  methods: {
    async getDevices() {
      try {
        let res = await axios.get("shirt_orders/cutter/devices");
        this.devices = res.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async getOverview() {
      if (this.data.from_date && this.data.to_date) {
        try {
          let res = await axios.get("/shirt_orders/cutter/overview", {
            params: this.data,
          });
          this.rows = res.data;
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      } else {
        toastr.error("Please Select Dates");
      }
    },

    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },
  },
};
</script>

<style scoped>
.table tbody tr td {
  vertical-align: top;
}
.table-responsive {
  overflow: scroll;
  margin-top: 20px;
}
.table {
  width: auto;
}
</style>
